module.exports = __webpack_public_path__ + "6d9f973e2ee663db08f2947557a6b1a7.svg";